import { useNavigate, useLocation } from "react-router-dom";
import { colors } from "../theme";

export default function TabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        padding: "8px 0 16px",
        borderTop: `1px solid ${colors.border}`,
        background: colors.bg,
      }}
    >
      <button
        onClick={() => navigate("/")}
        style={{
          fontSize: 24,
          color: path === "/" ? colors.white : colors.gray,
          padding: 8,
        }}
      >
        🏠
      </button>

      <button
        onClick={() => navigate("/create")}
        style={{
          background: colors.primary,
          borderRadius: 16,
          width: 48,
          height: 48,
          fontSize: 24,
          color: colors.bg,
          fontWeight: 800,
          boxShadow: "0 0 20px rgba(173,255,0,0.19)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        +
      </button>

      <button
        onClick={() => navigate("/profile")}
        style={{
          fontSize: 24,
          color: path === "/profile" ? colors.white : colors.gray,
          padding: 8,
        }}
      >
        👤
      </button>
    </div>
  );
}
